import { useEffect } from 'react';
import { CheatController } from '../../controllers/cheat-controller';
import { useGameDispatch } from '../global-context';

export const useCheating = () => {
  const dispatch = useGameDispatch();

  useEffect(() => {
    // No cheating if on production mode
    if (import.meta.env.VITE_ENABLE_CHEATING === 'false') return;

    const cheatController = new CheatController(dispatch);

    return () => {
      cheatController.unsubscribeAll();
    };
  }, []);
};
